var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.955 2.5L15 2.502l-9.847 9.849-1.18-1.179-1.178 1.179 2.062 2.062L2.5 16.771l1.178 1.178 2.358-2.357 2.062 2.062 1.179-1.178-1.179-1.18 9.855-9.853.002-2.943z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/sword.svg";
export { SvgSword as ReactComponent };